webpackJsonp([35783957827783],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Link from 'gatsby-link'
	
	var Project = function Project(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "project" },
	    _react2.default.createElement(
	      "span",
	      null,
	      _react2.default.createElement("img", { src: props.project.projectImg, className: "project-img" }),
	      _react2.default.createElement(
	        "p",
	        { className: "project-title" },
	        props.project.projectTitle
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      { className: "project-details" },
	      props.project.projectDetails
	    ),
	    props.project.projectRepo ? _react2.default.createElement(
	      "a",
	      {
	        className: "project-repo-link",
	        href: props.project.projectRepo,
	        target: "_blank",
	        rel: "noopener noreferrer"
	      },
	      "View Repo"
	    ) : null
	  );
	};
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _project = __webpack_require__(200);
	
	var _project2 = _interopRequireDefault(_project);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var projects = [{
	  projectSlug: 'friendchips',
	  projectTitle: 'Friendchips',
	  projectImg: 'https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/000/786/729/datas/gallery.jpg',
	  projectDetails: "HackMentalHealth 2019 - Judges' Recognition Award",
	  projectRepo: null,
	  projectView: 'https://devpost.com/software/friendchips'
	}, {
	  projectSlug: 'fig',
	  projectTitle: 'fig',
	  projectImg: 'https://raw.githubusercontent.com/Capstone1806/fig/master/screenshot.png',
	  projectDetails: 'ReactJS, Google Cloud Firestore, React DnD',
	  projectRepo: 'https://github.com/Capstone1806/fig',
	  projectView: '#'
	}, {
	  projectSlug: 'cormorant-ecommerce',
	  projectTitle: 'Cormorant',
	  projectImg: 'https://github.com/Supermodel-Matrices/GraceShopper/raw/master/screenshot.png',
	  projectDetails: 'ReactJS, Redux, Node ExpressJS, Sequelize, PassportJS, CSS',
	  projectRepo: 'https://github.com/Supermodel-Matrices/GraceShopper',
	  projectView: '#'
	}, {
	  projectSlug: 'neon-extension',
	  projectTitle: 'neon',
	  projectImg: 'https://raw.githubusercontent.com/hsujessica/neon/master/screenshot.png',
	  projectDetails: 'JavaScript, IndexedDB',
	  projectRepo: 'https://github.com/hsujessica/neon',
	  projectView: '#'
	}, {
	  projectSlug: 'guessing-game',
	  projectTitle: 'Guessing Game',
	  projectImg: 'https://raw.githubusercontent.com/hsujessica/guessing-game/42355350580f7632d853c7d6b74a57720cc702e0/screenshot.png',
	  projectDetails: 'JavaScript, jQuery, HTML, CSS',
	  projectRepo: 'https://github.com/hsujessica/guessing-game',
	  projectView: '#'
	}, {
	  projectSlug: 'fashion-database',
	  projectTitle: 'Fashion Database',
	  projectImg: 'https://raw.githubusercontent.com/hsujessica/fashion-database/51f2d5b98be6f1645f25da2992056dbd03df4fc1/screenshot.png',
	  projectDetails: 'PHP, MySQL, HTML, CSS',
	  projectRepo: 'https://github.com/hsujessica/fashion-database',
	  projectView: '#'
	}, {
	  projectSlug: 'food-for-four-legged-friends',
	  projectTitle: 'Food for Four-Legged Friends',
	  projectImg: 'https://github.com/hsujessica/pet-food-store/raw/master/screenshot.png',
	  projectDetails: 'PHP, JavaScript, HTML, CSS',
	  projectRepo: 'https://github.com/hsujessica/pet-food-store',
	  projectView: '#'
	}];
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'main-content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'projects-display' },
	      projects.map(function (project) {
	        return _react2.default.createElement(_project2.default, { project: project, key: project.projectTitle });
	      })
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-0d9f9ebec675041679ac.js